/*
 * @Author: your name
 * @Date: 2021-04-28 13:22:03
 * @LastEditTime: 2021-07-14 19:27:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/config/module/modal/order.config.js
 */
// 订单中心
export default () => ({
  refuseRefund: { // 售后处理-拒绝退款
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/refuseRefund.vue'
    )
  },
  batchUpdateValuableCoupon: { // 京东订单接口-批量更新有价券
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/batchUpdateValuableCoupon.vue'
    )
  },
  modifyLogistics: { // 异常订单-修改物流
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/modifyLogistics.vue'
    )
  },
  changeWarehouse: { // 异常订单-修改仓库
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/changeWarehouse.vue'
    )
  },
  PS_C_PRO_LABEL: { // 商品SPU-手工打标
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/PS_C_PRO_LABEL.vue'
    )
  },
  PS_C_PRO_CANCEL_LABEL: { // 商品SPU-取消打标
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/PS_C_PRO_LABEL.vue'
    )
  },
  UPDATE_CLAIM_RESULT: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/UPDATE_CLAIM_RESULT.vue'
    )
  },
  AGREERETURNGOODS: { // 售后工单-同意退换货
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/AGREERETURNGOODS.vue'
    )
  },
  ABNORMALORDER: { // 电商异常单-办理/驳回
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/ABNORMALORDER.vue'
    )
  },
  SOLDOUT: { // 平台店铺商品发布-下架
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/pages/orderCenter/productRelease/SOLDOUT.vue'
    )
  },
  EDITAMT: { // 平台店铺商品发布-零售价
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/pages/orderCenter/productRelease/EDITAMT.vue'
    )
  },
  SENDORDERRECEIVING: { // 全渠道自提单-拒单
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/pages/orderCenter/omniChannel/dialog/dialogRejectOrder.vue'
    )
  },
  SENDORDERREFUSEORDER: { // 全渠道自提单-核销
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/pages/orderCenter/omniChannel/dialog/dialogChargeOff.vue'
    )
  },
  SENDORDERSEND: { // 全渠道发货单-发货
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/pages/orderCenter/omniChannel/dialog/dialogChargeOff.vue'
    )
  },
  NOTIFYSHIPMENTRE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/pages/orderCenter/tbOrderManager/NOTIFYSHIPMENTRE.vue'
    ),
  },
  REPLACEABNORMALGOODS: { // 唯品会退货单- 替换异常商品
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/replaceGoodsDetail.vue'
    ),
  },
  PAYDETAIL: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      'allpages/orderCenter/pay/payDetail.vue'
    ),
  },
  ORDERRETURN: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      'allpages/orderCenter/returnOrder/orderReturnchange.vue'
    ),
    labelName: t('返回')
  },
  SAVE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      'allpages/orderCenter/returnOrder/save.vue'
    ),
    labelName: t('保存'),
  },
  // JIT配货单修改仓库测试弹框
  MODIFYWAREHOUSE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/modifyWarehouse.vue'
    ),
  },
  // JIT拣货单 (创建拣货单)
  VIPCREATEPICKORDER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/vipCreatePickorder.vue'
    )
  },
  // JIT配货单(手工占单)
  VIPDISTRIBUTIONOCCUS: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/vipDistributionOccus.vue'
    )
  },
  // JIT配货单(匹配出仓单)->改名为(匹配唯品会入库单)
  DELIVERYORDER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/deliveryOrder.vue'
    )
  },
  // JIT PO单(下载PO单)
  VIPDOWNLOADPO: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/vipDownloadPo.vue'
    )
  },
  // JIT仓库管理(生成出仓单)
  JTWAREHOUSE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/jtWarehouse.vue'
    )
  },
  MODIFYLOGISTICSNUMBER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/modifyLogisticsNumber.vue'
    )
  },
  MODIFYWMS: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/modifyWms.vue'
    )
  },

  CREATEGRN: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/createGrn.vue'
    )
  },
  REFUSETOPAYOCBRETURNAFSEND: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/returngood/refuseToPayOcBReturnAfSend.vue'
    )
  },
  PICKORDEREXPORT: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/returngood/pickorderExport.vue'
    )
  },
  // JIT配货单-换吊牌
  EXCHANGETAG: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/exchangeTag.vue'
    )
  },
  CHANGETAG: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/changeTag.vue'
    ),
    labelName: t('换吊牌'),
    isList: false
  },
  MANUAL: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/manual.vue'
    )
  },
  FOURCE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/force.vue'
    )
  },

  REMITFAIL:{
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/remitFail.vue'
    ) //
  },
  // 唯品会入库单-列表详情-修改发货时间button
  EDITCONSIGNMENTTIME: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/editConsignmentTime.vue')
  },
  // 零售发货单预导入 - 修改店铺
  PREORDERUPDATESHOP: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/preOrderUpdateShop.vue'
      )
  },
  // 零售发货单预导入 - 按流水转入
  TRANSFERREDBYFLOW: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/transferredByFlow.vue'
      )
  },
  // 零售发货单预导入 - 按流水转入
  preOrderImport: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/preOrderImport.vue'
      )
  },
});
